import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    copyUploadLink: string;
    createdBy: (name: string) => string | React.ReactNode;
    uploadLinkCopied: string;
    subNavLabel: string;
    allUploadLinks: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the menu item that copies a folder's upload link */
            copyUploadLink: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CopyUploadLinkMenuItem.copyUploadLink?c=2sx2mdunqxv4t", defaultMessage: "Copy Upload Link" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Secondary label showing who created an upload link */
            createdBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "CopyUploadLinkMenuItem.createdBy?c=3b6n3jywy3r2i", defaultMessage: "Created by {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Success toast shown after an upload link is copied to the clipboard */
            uploadLinkCopied: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CopyUploadLinkMenuItem.uploadLinkCopied?c=2tsisvvj8wtij", defaultMessage: "Upload link copied" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the submenu containing upload links */
            subNavLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CopyUploadLinkMenuItem.subNavLabel?c=2vjqwm8hkpy6i", defaultMessage: "Active Upload Links" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Menu entry that navigates to the project's Upload Links settings page */
            allUploadLinks: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CopyUploadLinkMenuItem.allUploadLinks?c=2pvh5m82un4fp", defaultMessage: "All Upload Links" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
